module.exports = __webpack_public_path__ + "img/weight1.a6fc76ef.svg";